import {
    Directive,
    ElementRef, EventEmitter, Input, Output,
    Renderer2,
} from '@angular/core';

@Directive({
    selector: '[molder]'
})
export class MolderDirective {

    private _element: HTMLImageElement;

    @Input('molder') molder: '1x1' | '1x2' | '2x3' | '3x2' | '4x3' | '16x9' | '15x10';
    @Input('molder-class') molderClass: string = '';
    @Input('molder-width') molderWidth: any = '100%';
    @Input('molder-midth') molderMidth: any = '100%';
    @Input('molder-bicon') molderBicon: string = '';

    @Output('molder-errro') _error: EventEmitter<any> = new EventEmitter();

    constructor(element: ElementRef, public renderer: Renderer2) {

        this._element = element.nativeElement;

    }

    ngAfterViewInit() {

        this.molderWidth = this.molderWidth + ((typeof this.molderWidth == "number") ? 'px' : '');
        this.molderMidth = this.molderMidth + ((typeof this.molderMidth == "number") ? 'px' : '');

        this._element.style.setProperty('width', this.molderWidth);
        this._element.style.setProperty('max-width', this.molderMidth);

        const imgMolde = document.createElement('img');
        imgMolde.src = 'assets/img/molde/md-' + this.molder + '.png';
        imgMolde.className = this._element.className;
        imgMolde.style.setProperty('width', this.molderWidth);
        imgMolde.style.setProperty('max-width', this.molderMidth);
        this._element.parentElement.insertBefore(imgMolde, this._element);

        this.renderer.addClass(this._element, 'display-none');
        this._element.onload = () => this.onLoaded(imgMolde);
        this._element.onerror = () => this._error.emit(imgMolde);

    }

    onLoaded(imgMolde) {

        if (!imgMolde.parentElement) return;

        imgMolde.parentElement.removeChild(imgMolde);
        this.renderer.removeClass(this._element, 'display-none');

    }

    onError(imgMolde) {

        if (!this.molderBicon) {
            this._error.emit(imgMolde);
            return;
        }


        /** EXEMPLO **/
        /*************
         <div class="position-relative margin-auto-x margin-bottom-30" style="max-width: 150px;">
         <img src="assets/img/molde/md-1x1.png" class="w-10 display-block">
         <img [src]="changes[0].BrandedLogo" class="w-10 position-absolute left-0 top-0"/>
         </div>

         <img [src]="changes[0].BrandedLogo" [molder-class]="'margin-bottom-30'"/>

         */

        /*
        this.molderWidth = this.molderWidth + ((typeof this.molderWidth == "number") ? 'px' : '');
        this.molderMidth = this.molderMidth + ((typeof this.molderMidth == "number") ? 'px' : '');

        const divMolde = document.createElement('div');
        divMolde.className = 'position-relative margin-auto-x ' + this.molderClass;
        divMolde.style.setProperty('width', this.molderWidth);
        divMolde.style.setProperty('max-width', this.molderMidth);

        const imgMolde = document.createElement('img');
        imgMolde.src = 'assets/img/molde/md-' + this.molder + '.png';
        imgMolde.className = 'w-10 display-block';

        this.renderer.addClass(this._element, 'w-10');
        this.renderer.addClass(this._element, 'position-absolute');
        this.renderer.addClass(this._element, 'left-0');
        this.renderer.addClass(this._element, 'top-0');

        this.renderer.addClass(this._element, 'top-0');

        this._element.parentElement.insertBefore(imgMolde, this._element);
        this.renderer.appendChild(divMolde, imgMolde);
        this.renderer.appendChild(divMolde, this._element);
*/
    }

}



// WEBPACK FOOTER //
// ./src/directives/molder.ts